// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"LowerContainer_Wrapper__jaPFX","Line":"LowerContainer_Line__vLeKB","Heading":"LowerContainer_Heading__18jxR"};